import { SET_ID_CLIENT_ENREGISTREMET, SET_ID_ENREGISTREMENT_ENTETE } from "./types";

export const _setIdClient = (idClient) => dispatch => {

    dispatch({ type: SET_ID_CLIENT_ENREGISTREMET, value: idClient })
}

export const _setIdEnregistrementEntete = (idEnregistrementEntete) => dispatch => {
    dispatch({type: SET_ID_ENREGISTREMENT_ENTETE, value:idEnregistrementEntete})
}